const fonts = {
  family: {
    default:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;',
  },
  weight: {
    normal: 400,
    medium: 600,
    bold: 700,
  },
  size: {
    small: '12px',
    default: '14px',
    medium: '18px',
    large: '24px',
    xlarge: '30px',
  },
}

export default fonts
